function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M59.29 38.408c.935 0 1.676-.74 1.676-1.677v-.896c0-.936-.74-1.677-1.676-1.677-.936 0-1.677.741-1.677 1.677v.896c0 .936.741 1.677 1.677 1.677z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.29 47.258c.935 0 1.676-.74 1.676-1.676v-3.743c0-.936-.74-1.677-1.676-1.677-.936 0-1.677.741-1.677 1.677v3.743c0 .896.741 1.676 1.677 1.676z",
  fill: "#00BAC3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M64.32 59.89l2.573-2.534c.468-.429.623-1.13.428-1.715a1.638 1.638 0 00-1.364-1.131l-3.548-.507-1.599-3.236c-.273-.585-.857-.936-1.52-.936a1.73 1.73 0 00-1.52.936l-1.6 3.236-3.547.507a1.701 1.701 0 00-1.365 1.13c-.195.624-.039 1.287.43 1.716l2.572 2.534-.623 3.548c-.117.624.156 1.248.662 1.638.507.39 1.21.428 1.755.117l3.158-1.677 3.158 1.677c.234.117.507.195.78.195.35 0 .702-.117.974-.312.507-.39.78-1.014.663-1.638l-.468-3.548zm-5.77.273l-.937.507.195-1.053c.078-.545-.078-1.091-.468-1.481l-.78-.741 1.053-.156a1.628 1.628 0 001.248-.936l.468-.974.468.974c.234.507.702.858 1.247.936l1.053.156-.78.74c-.39.39-.584.937-.468 1.482l.195 1.053-.935-.507a1.775 1.775 0 00-.78-.195c-.273 0-.546.078-.78.195zM81.786 50.455a1.719 1.719 0 00-2.183-.974l-.82.311a1.719 1.719 0 00-.974 2.184c.273.663.897 1.091 1.56 1.091.195 0 .39-.039.585-.117l.818-.312a1.72 1.72 0 001.014-2.183z",
  fill: "#384B51"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.855 55.056c.273.663.897 1.092 1.56 1.092.195 0 .39-.04.584-.117l3.51-1.326a1.719 1.719 0 00.974-2.183 1.719 1.719 0 00-2.183-.975l-3.51 1.326c-.857.35-1.286 1.325-.935 2.183z",
  fill: "#00BAC3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.77 51.976c.351-.858-.117-1.833-.974-2.184l-.819-.311c-.858-.351-1.832.117-2.183.974-.351.858.117 1.833.974 2.184l.82.312c.194.078.389.117.584.117.702-.04 1.326-.43 1.598-1.092z",
  fill: "#384B51"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M46.58 56.03c.194.078.39.117.584.117.663 0 1.326-.39 1.56-1.091.35-.858-.117-1.833-.975-2.183l-3.509-1.326c-.858-.351-1.832.117-2.183.975-.351.857.117 1.832.975 2.183l3.547 1.326z",
  fill: "#00BAC3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M74.885 75.018l-.585-.663c-.624-.702-1.676-.78-2.378-.156-.702.624-.78 1.677-.156 2.378l.585.663c.35.39.78.585 1.286.585.39 0 .78-.117 1.092-.429.663-.624.74-1.676.156-2.378z",
  fill: "#384B51"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M70.986 70.534l-2.456-2.846c-.624-.702-1.677-.78-2.378-.156-.702.624-.78 1.676-.156 2.378l2.456 2.846c.35.39.819.585 1.287.585.39 0 .78-.117 1.091-.429.702-.624.78-1.676.156-2.378z",
  fill: "#00BAC3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M47.125 74.2c-.701-.625-1.754-.547-2.378.155l-.585.663c-.624.702-.546 1.754.156 2.378.312.273.702.429 1.092.429.468 0 .936-.195 1.286-.585l.585-.663c.624-.701.546-1.793-.156-2.378z",
  fill: "#384B51"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M52.896 67.532c-.702-.624-1.755-.546-2.379.156l-2.456 2.846c-.624.702-.546 1.754.156 2.378.312.273.702.43 1.092.43.468 0 .936-.196 1.286-.586l2.457-2.846c.623-.702.545-1.754-.156-2.378z",
  fill: "#00BAC3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M79.212 64.296l-.78-.39c-.818-.429-1.832-.078-2.26.74-.43.82-.079 1.833.74 2.262l.78.39c.234.117.507.195.74.195.624 0 1.21-.35 1.482-.936a1.675 1.675 0 00-.702-2.26z",
  fill: "#384B51"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M70.557 59.93c-.819-.43-1.832-.079-2.261.74-.429.819-.078 1.832.74 2.261l3.354 1.716c.234.117.506.195.74.195.624 0 1.209-.351 1.482-.936.429-.819.078-1.832-.741-2.261l-3.314-1.716z",
  fill: "#00BAC3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M40.185 67.454c.273 0 .507-.078.741-.195l.78-.39c.819-.428 1.17-1.442.74-2.26-.428-.82-1.442-1.17-2.26-.742l-.78.39c-.82.43-1.17 1.443-.741 2.262.312.623.897.935 1.52.935z",
  fill: "#384B51"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M45.449 64.803c.273 0 .506-.078.74-.195l3.353-1.715c.82-.43 1.17-1.443.741-2.262-.429-.819-1.442-1.17-2.261-.74l-3.353 1.715c-.819.429-1.17 1.443-.74 2.261a1.73 1.73 0 001.52.936z",
  fill: "#00BAC3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M71.844 44.568c.428 0 .896-.156 1.208-.507l.624-.624a1.707 1.707 0 00-.039-2.378 1.707 1.707 0 00-2.378.039l-.624.624a1.707 1.707 0 00.039 2.378c.312.312.74.468 1.17.468z",
  fill: "#384B51"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M65.762 50.962c.428 0 .896-.156 1.208-.507l2.612-2.73a1.707 1.707 0 00-.039-2.377 1.707 1.707 0 00-2.378.039l-2.612 2.729a1.707 1.707 0 00.039 2.378c.312.312.74.468 1.17.468z",
  fill: "#00BAC3"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M44.513 43.437l.624.624c.312.351.78.507 1.209.507.429 0 .818-.156 1.17-.468.662-.624.701-1.715.038-2.378l-.623-.624c-.624-.663-1.716-.702-2.379-.039-.663.624-.702 1.716-.039 2.378z",
  fill: "#384B51"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M51.22 50.416c.311.351.779.507 1.208.507.429 0 .819-.156 1.17-.468.662-.623.701-1.715.038-2.378l-2.612-2.73c-.624-.662-1.715-.701-2.378-.038-.663.624-.702 1.715-.039 2.378l2.612 2.73z",
  fill: "#00BAC3"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M59.29 78.449c-.936 0-1.677.74-1.677 1.676v.897c0 .936.741 1.676 1.677 1.676.935 0 1.676-.74 1.676-1.676v-.897c0-.897-.74-1.676-1.676-1.676z",
  fill: "#384B51"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M59.29 69.638c-.936 0-1.677.74-1.677 1.676v3.743c0 .936.741 1.676 1.677 1.676.935 0 1.676-.74 1.676-1.676v-3.743c0-.936-.74-1.676-1.676-1.676z",
  fill: "#00BAC3"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M81.903 82.036h-1.17v-1.21c0-.935-.74-1.676-1.676-1.676-.936 0-1.677.741-1.677 1.677v1.209h-1.17c-.935 0-1.676.74-1.676 1.676 0 .936.74 1.676 1.677 1.676h1.17v1.21c0 .935.74 1.676 1.676 1.676.936 0 1.676-.741 1.676-1.677v-1.209h1.17c.936 0 1.676-.74 1.676-1.676.04-.936-.74-1.676-1.676-1.676zM76.172 37.238h1.17v1.209c0 .935.74 1.676 1.676 1.676.936 0 1.676-.74 1.676-1.676v-1.209h1.17c.935 0 1.676-.74 1.676-1.676 0-.936-.74-1.677-1.676-1.677h-1.17v-1.209c0-.935-.74-1.676-1.676-1.676-.936 0-1.677.74-1.677 1.676v1.21h-1.17c-.935 0-1.676.74-1.676 1.676 0 .935.78 1.676 1.677 1.676zM42.408 82.036h-1.17v-1.21c0-.935-.74-1.676-1.676-1.676-.936 0-1.677.741-1.677 1.677v1.209h-1.17c-.935 0-1.676.74-1.676 1.676 0 .936.74 1.676 1.677 1.676h1.17v1.21c0 .935.74 1.676 1.676 1.676.935 0 1.676-.741 1.676-1.677v-1.209h1.17c.935 0 1.676-.74 1.676-1.676 0-.936-.78-1.676-1.676-1.676zM36.676 37.238h1.17v1.209c0 .936.74 1.676 1.677 1.676.935 0 1.676-.74 1.676-1.676v-1.209h1.17c.935 0 1.676-.74 1.676-1.676 0-.936-.74-1.677-1.676-1.677h-1.17v-1.208c0-.936-.74-1.677-1.676-1.677-.936 0-1.677.741-1.677 1.677v1.208h-1.17c-.935 0-1.676.741-1.676 1.677s.74 1.676 1.676 1.676z",
  fill: "#384B51"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M69.66 34.509c0-.78-.624-1.404-1.403-1.404-.78 0-1.404.624-1.404 1.404 0 .78.624 1.403 1.404 1.403.78 0 1.403-.623 1.403-1.403zM51.726 34.509c0-.78-.624-1.404-1.403-1.404-.78 0-1.404.624-1.404 1.404 0 .78.624 1.403 1.404 1.403.78 0 1.403-.623 1.403-1.403zM85.256 74.199c0-.78-.624-1.404-1.404-1.404-.78 0-1.403.624-1.403 1.404 0 .78.624 1.403 1.403 1.403.78 0 1.404-.624 1.404-1.403zM85.256 45.036c0-.78-.624-1.403-1.404-1.403-.78 0-1.403.623-1.403 1.403s.624 1.404 1.403 1.404c.78 0 1.404-.663 1.404-1.404z",
  fill: "#00BAC3"
});

function SvgFirework(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

export default SvgFirework;